(function () {
  const settings = window.theme && window.theme.settings && window.theme.settings.freePouch;
  if (!settings || !settings.enabled || !settings.variantId) return;

  const giftVariantId = String(settings.variantId);
  const minItemCount = Number(settings.minItemCount || 3);
  const giftTitle = settings.title || 'Free pouch';
  const routes = window.theme.routes || {};
  const cartUrl = routes.cart_url || '/cart';
  const cartAddUrl = routes.cart_add_url || '/cart/add.js';
  const cartUpdateUrl = routes.cart_update_url || '/cart/update.js';

  let syncing = false;
  let syncQueued = false;
  let syncTimer = null;

  function normalizeId(id) {
    return id == null ? '' : String(id);
  }

  function lineProperties(item) {
    return item && item.properties ? item.properties : {};
  }

  function isGiftLine(item) {
    if (normalizeId(item.variant_id) === giftVariantId) return true;
    const props = lineProperties(item);
    return Boolean(props._bundle_gift || props._auto_free_pouch);
  }

  function countQualifyingItems(items) {
    return (items || []).reduce((sum, item) => {
      if (isGiftLine(item)) return sum;
      return sum + Number(item.quantity || 0);
    }, 0);
  }

  function hasGiftLine(items) {
    return (items || []).some((item) => normalizeId(item.variant_id) === giftVariantId);
  }

  function managedGiftLines(items) {
    return (items || []).filter((item) => {
      if (normalizeId(item.variant_id) !== giftVariantId) return false;
      const props = lineProperties(item);
      return Boolean(props._auto_free_pouch || props._bundle_gift);
    });
  }

  function variantIdForAjax() {
    const asNumber = Number(giftVariantId);
    return Number.isSafeInteger(asNumber) ? asNumber : giftVariantId;
  }

  async function runSync() {
    if (syncing) {
      syncQueued = true;
      return;
    }

    syncing = true;
    document.dispatchEvent(new CustomEvent('shapes:cart:lock'));

    try {
      const cartRes = await fetch(`${cartUrl}.js`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      const cart = await cartRes.json();
      if (!cartRes.ok) {
        throw new Error(cart.description || cart.message || 'Could not load cart.');
      }

      const qualifyingCount = countQualifyingItems(cart.items);
      const shouldHaveGift = qualifyingCount >= minItemCount;

      if (shouldHaveGift && !hasGiftLine(cart.items)) {
        const addRes = await fetch(cartAddUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            items: [
              {
                id: variantIdForAjax(),
                quantity: 1,
                properties: { _auto_free_pouch: giftTitle },
              },
            ],
          }),
        });
        const payload = await addRes.json();
        if (!addRes.ok) {
          throw new Error(payload.description || payload.message || payload.error || 'Could not add free pouch.');
        }

        document.dispatchEvent(new CustomEvent('theme:update:cart'));
        document.body.dispatchEvent(
          new CustomEvent('shapes:cart:afteradditem', {
            bubbles: true,
            detail: { response: payload, sourceId: 'auto-free-pouch' },
          })
        );
        return;
      }

      if (!shouldHaveGift) {
        const giftsToRemove = managedGiftLines(cart.items);
        if (!giftsToRemove.length) return;

        const updates = {};
        giftsToRemove.forEach((item) => {
          updates[item.key] = 0;
        });

        const updateRes = await fetch(cartUpdateUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ updates }),
        });
        const payload = await updateRes.json();
        if (!updateRes.ok) {
          throw new Error(payload.description || payload.message || 'Could not update cart.');
        }

        document.dispatchEvent(new CustomEvent('theme:update:cart'));
      }
    } catch (error) {
      console.error('[auto-free-pouch]', error);
    } finally {
      syncing = false;
      document.dispatchEvent(new CustomEvent('shapes:cart:unlock'));

      if (syncQueued) {
        syncQueued = false;
        runSync();
      }
    }
  }

  function scheduleSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(runSync, 150);
  }

  document.addEventListener('theme:cart:change', scheduleSync);
  document.addEventListener('DOMContentLoaded', scheduleSync);
})();
